import { Directive, ElementRef, HostListener, Input, OnInit, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumber]'
})
export class AppNumberDirective implements OnInit {

  @Input() isNegative: boolean;
  @Input() decimals: number;
  @Input() allowedEmpty = false;

  regExpFloat = (/^[+-]?\d+(\.\d+)?$/);
  regExpFloatWithDecimalPoint = (/^[+-]?\d+(\.)?$/);
  regExpFloat2 = (/^[+-]?\d+(\,\d+)?$/);
  regExpFloatWithDecimal2 = (/^[+-]?\d+(\,)?$/);

  maxValue = 0;

  beforeValue = '';
  writeDecimal = false;

  constructor(@Self() private ngControl: NgControl, private element: ElementRef) {
  }

  @HostListener('keypress', ['$event']) onKeyPress(evento: KeyboardEvent): boolean {

    const value: string = this.element.nativeElement.value;
    if (evento.key === '-') {
      if (!this.isNegative) {
        return false;
      } else {
        if (value.indexOf('-') !== -1) {
          return false;
        }
      }
    } else if (evento.key === '.' || evento.key === ',') {
      if (!this.decimals) {
        return false;
      } else {
        if (value.indexOf('.') !== -1 || value.indexOf(',') !== -1) {
          return false;
        }
      }
      this.writeDecimal = true;
    } else if (evento.key === 'e' || evento.key === 'E') {
      return false;
    } else if (evento.key === '+') {
      return false;
    }
  }

  @HostListener('input', ['$event']) onImput(): void {

    let value: string = this.element.nativeElement.value;
    if (this.decimals && value === '') {
      this.element.nativeElement.select();
      value = window.getSelection().toString();
      value = value.replace(/\,/gi, '.');
      this.element.nativeElement.type = 'text';
      this.element.nativeElement.selectionStart = value.length;
      // this.element.nativeElement.value = value;
      this.ngControl.control.setValue(value);
    }

    if (value !== '') {

      if (value.length > this.element.nativeElement.maxLength) {
        this.ngControl.control.setValue(this.beforeValue);
        // this.element.nativeElement.value = this.beforeValue;
      } else {
        try {
          if (this.regExpFloat.test(value) || this.regExpFloatWithDecimalPoint.test(value) || this.regExpFloat2.test(value) || this.regExpFloatWithDecimal2.test(value)) {
            const numberVar = parseFloat(value);
            if (numberVar > this.maxValue) {
              this.ngControl.control.setValue(this.beforeValue);
              // this.element.nativeElement.value = this.beforeValue;
            }
          } else {
            this.ngControl.control.setValue(this.beforeValue);
            // this.element.nativeElement.value = this.beforeValue;
          }
        } catch (error) {
          this.ngControl.control.setValue(this.beforeValue);
          // this.element.nativeElement.value = this.beforeValue;
        }
      }
    }

    this.beforeValue = this.element.nativeElement.value;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  @HostListener('change', ['$event']) change(event: any): void {
    try {
      if (this.decimals) {
        let value: string = this.element.nativeElement.value;
        value = value.replace(/\,/gi, '.');
        if (value === '' && this.allowedEmpty) {
          this.ngControl.control.setValue(value);
        } else {
          const num = Number(value);
          const truncNumber = num.toFixed(this.decimals);
          if (this.getnumDecimalsValue(value) > this.decimals) {
            this.ngControl.control.setValue(num);
          } else {
            this.ngControl.control.setValue(truncNumber);
          }
        }

      }
    } catch (error) {
      setTimeout(() => {
        event.target.focus();
        }, 10);
    }
  }


  ngOnInit(): void {
    let aux = '9'.repeat(this.element.nativeElement.maxLength);
    if (this.decimals) {
      aux = aux.substr(0, aux.length - this.decimals - 1) + '.' + aux.substr(aux.length - this.decimals);
    }
    this.maxValue = parseFloat(aux);
  }


  private getnumDecimalsValue(value: string): number {
    const indexPointDecimal = value.indexOf('.');
    if (indexPointDecimal > -1) {
      const numDecimals = value.substr((indexPointDecimal + 1), value.length);
      return numDecimals.length;
    }
    return 0;
  }

}
